module.exports = __webpack_public_path__ + "img/results_hw_axis.30fe5977.png";